import { useShouldShowDevTeamFeature } from './_base';

export const useAiFilterPromptFeatureToggle = useShouldShowDevTeamFeature;
